/**
 * IA NAS AGENCIAS — VIDEO 6/9 (Revelação)
 * SlideType: terminal-check | 10s | 720x900
 */
import React from "react";
import {AbsoluteFill, useCurrentFrame, interpolate, Easing} from "remotion";
import {TOKEN_PRESETS, FONT_PRESETS} from "../../templates/carrossel/EditorialTechNews";

const CLAMP = {extrapolateLeft: "clamp" as const, extrapolateRight: "clamp" as const};
const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

const termColors = {bg: "#0D1117", border: "rgba(255,255,255,0.08)", prompt: "#4ADE80", error: "#F87171", text: "#C9D1D9", comment: "#8B949E"};

export const IAA06Revelacao: React.FC = () => {
  const frame = useCurrentFrame();

  return (
    <AbsoluteFill style={{backgroundColor: "#1A1D26"}}>
      <div style={{position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px"}} />
      <div style={{position: "absolute", top: 30, left: 50, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_PRESETS.mono, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: "#888888"}}>IA NAS AGENCIAS</div>
      <div style={{position: "absolute", top: 100, left: 50, opacity: fadeIn(frame, 5, 20), transform: `translateY(${slideUp(frame, 5, 20)})`, fontFamily: FONT_PRESETS.serif, fontSize: 48, fontWeight: 700, lineHeight: 1.15, color: "#FFFFFF", maxWidth: 620}}>O problema não é IA.</div>
      <div style={{position: "absolute", top: 190, left: 50, right: 50, opacity: fadeIn(frame, 15, 30), fontFamily: FONT_PRESETS.serif, fontSize: 24, fontWeight: 400, lineHeight: 1.4, color: "#C8C4C0"}}>O problema é que você está tentando adicionar IA no processo errado. Quem joga IA no caos, tem caos mais rápido.</div>
      <div style={{position: "absolute", top: 340, left: 50, opacity: fadeIn(frame, 30, 45), transform: `translateY(${slideUp(frame, 30, 45, 40)})`, background: termColors.bg, border: `1px solid ${termColors.border}`, borderRadius: 12, padding: "0 0 20px 0", maxWidth: 620, boxShadow: "0 8px 32px rgba(0,0,0,0.4)"}}>
        <div style={{display: "flex", alignItems: "center", padding: "10px 16px", borderBottom: `1px solid ${termColors.border}`, gap: 8}}>
          <div style={{width: 12, height: 12, borderRadius: "50%", background: "#FF5F57"}} /><div style={{width: 12, height: 12, borderRadius: "50%", background: "#FEBC2E"}} /><div style={{width: 12, height: 12, borderRadius: "50%", background: "#28C840"}} />
          <div style={{flex: 1}} />
          <span style={{fontFamily: FONT_PRESETS.mono, fontSize: 12, color: termColors.comment}}>diagnóstico</span>
        </div>
        <div style={{padding: "16px 20px", display: "flex", flexDirection: "column", gap: 10}}>
          <div style={{fontFamily: FONT_PRESETS.mono, fontSize: 15, lineHeight: 2, color: termColors.error}}>✗ IA + processo caótico</div>
          <div style={{fontFamily: FONT_PRESETS.mono, fontSize: 15, lineHeight: 2, color: termColors.text}}>→ resultado: caos acelerado</div>
          <div style={{fontFamily: FONT_PRESETS.mono, fontSize: 15, lineHeight: 2, color: termColors.prompt}}>✓ IA + processo estruturado</div>
          <div style={{fontFamily: FONT_PRESETS.mono, fontSize: 15, lineHeight: 2, color: termColors.prompt}}>→ resultado: produtividade 3x</div>
        </div>
      </div>
      <div style={{position: "absolute", bottom: 40, left: 50, right: 50, display: "flex", justifyContent: "space-between", opacity: fadeIn(frame, 40, 50)}}>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 15, color: "#888888"}}>@guilhermeribeiro.ai</span>
        <span style={{fontFamily: FONT_PRESETS.sans, fontSize: 13, color: "#888888"}}>6/9</span>
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
